import React, { useState, useEffect, useRef } from "react";
import * as Yup from "yup";
import Form from "../../form/components/Form/Form";
import FormField from "../../form/components/FormField/FormField";
import Button from "../../form/components/Button/Button";
import ErrorMessage from "../../form/components/ErrorMessage/ErrorMessage";
import { ImCancelCircle } from "react-icons/im";
import { toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";
import "./AssignSlideModal.css";


import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import { collection, arrayUnion, getDoc, doc , updateDoc} from "firebase/firestore";
import { db } from "../../../firebase/firebase-config";

import { Select } from 'antd';

let { Option } = Select;

  const override = {
    marginTop: "20px",
  };


function AssignSlideModal({  
    onClose,
    onContentAdded,  
    selectedSlide,
    caseList
}:any) {

    // console.log("*****************************")
    // console.log(caseList)


    const [error, setError] = useState<any>(null);
    const [selectedCase, setSelectedCase] = useState(null);
    const [loading, setLoading] = useState(false);
    


    const handleAddUser = async (e:any) => {

        e.preventDefault()
  
        try{
    
          if(selectedCase != null) {
            const docRef = doc(collection(db,"Cases"),selectedCase)
            const slideRef = doc(collection(db,"Slides"),selectedSlide)
            // Use getDoc() to fetch the document
            const docSnapshot = await getDoc(docRef);
            const slideSnapshot = await getDoc(slideRef);
        
            if (!docSnapshot.exists() || !slideSnapshot.exists()) {
              throw new Error('Document does not exist!');
            }
        
            await updateDoc(docRef, {
              assigned_sldes: arrayUnion(selectedSlide)
            });

            await updateDoc(slideRef,{
              assigned_case: selectedCase
            })
        
            toast.success("Slide Assigned to New Case", {
              pauseOnHover: false,
              closeOnClick: true,
            });
          }
    
        }catch(e:any){
          // console.log(e)
          console.error('Error updating array field:', error);
        }
    
        
        if(selectedCase)
          onClose()
      };


      const OPTIONS = ['Apples', 'Nails', 'Bananas', 'Helicopters', 'Bananas', 'Helicopters', 'Bananas', 'Helicopters', 'Bananas', 'Helicopters'];
      const [selectedItems, setSelectedItems] = useState<string[]>([]);

      const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
      let containerDiv: any = document.getElementById('slide_select_container');

      const options = [
        {
          value: '1',
          label: 'Not Identified',
        },
        {
          value: '2',
          label: 'Closed',
        },
        {
          value: '3',
          label: 'Communicated',
        },
        {
          value: '4',
          label: 'Identified',
        },
        {
          value: '5',
          label: 'Resolved',
        },
        {
          value: '6',
          label: 'Cancelled',
        },
      ];

      return (
        <div>
          <div  className="modal-container" id="assign-slide">
            <div className="modal-head">
              <p className="modal-title">Attach existing Slide to Case</p>
              <ImCancelCircle
                style={{ cursor: "pointer" }}
                onClick={onClose}
                size={22}
                color="#fff"
              />
            </div>
            <div className="modal-content">
              <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <BeatLoader
                  color="#3080ED"
                  loading={loading}
                  cssOverride={override}
                />
              </div>
              <form action="" className="auth-form">
                {error && <ErrorMessage error={error} visible={true} />}
    
                  <p className="label-text">Select a Case to assign slide to: </p>
                   <Select
                   className={'slide_select'}
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Search to Select"
                    optionFilterProp="label"
                    popupClassName="dropDownItems"
                    filterOption={(input: any, option: any) =>{
                      // console.log(option)
                      return (option?.children as string)?.toLowerCase()?.includes((input as string)?.toLowerCase());
                    }}
                    onSelect={(val: any) => setSelectedCase(val)}
                    filterSort={(optionA, optionB) =>
                      (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                    }
                  >
                    
                  {caseList.map((option: any, index: any) => (
                      <Option key={index} value={option.name}>
                        {option.CID}
                      </Option>
                    ))}
                  </Select>

    
                  <br />
                  <br />
    
                  {!loading && (
                    <>
                      {/* <Button
                        isOutLined={true}
                        isFullWidth={false}
                        title="ADD REVIEWER"
                        onClick = {handleAddUser}
                      /> */}
    
                      <button
                        onClick = {handleAddUser}
                        style={{
                          padding: 15,
                          
                          border: "1px solid #000",
                          borderRadius: 5,
                          backgroundColor: "white",
                          textTransform: "uppercase",
                          cursor: 'pointer',
                          color: "#000",
                        }}
                      >
                        ATTACH
                      </button>
    
                      <button
                        onClick={onClose}
                        style={{
                          padding: 15,
                          width: 100,
                          marginLeft: 25,
                          border: "1px solid #000",
                          borderRadius: 5,
                          backgroundColor: "white",
                          textTransform: "uppercase",
                          cursor: 'pointer',
                          color: "#000",
                        }}
                      >
                        Cancel
                      </button>
                    </>
                  )}
    
              </form>
            </div>
          </div>
          <div className="modal-shadow" onClick={onClose}></div>
        </div>
      );
}

export default AssignSlideModal